import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { DatePipe, DecimalPipe, formatDate } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { TableComponent } from '@components/abstract/table/table.component';
import { TransactionDto } from '@dto/transactionDto';
import { TransactionSuccess } from '@enums/transaction-success.enum';
import { TableColumn } from '@models/tableColumn';
import { TableOptions } from '@models/tableOptions';
import { TransactionsService } from '@services/entity/transactions.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { plainToClass } from 'class-transformer';
import { DEDatePipe } from '../../../../pipes/de-date.pipe';
import '@angular/localize/init';
import { KwhPipe } from '../../../../pipes/kwh.pipe';


@Component({
  selector: 'app-chargingstation-transactions-table',
  templateUrl: './chargingstation-transactions-table.component.html',
  styleUrls: ['./chargingstation-transactions-table.component.scss']
})
export class ChargingstationTransactionsTableComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'ChargingstationTransactionsTableComponent';

  private chargingStationId: string;
  public entities: TransactionDto[];


  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn1:Trans-ID`, property: 'transactionId' },
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn2:Status`, property: 'successMessage' },
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn3:Grund`, property: 'reason' },
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn4:Vorname`, property: 'userFirstName' },
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn5:Nachname`, property: 'userLastName' },
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn6:kWh`, property: 'meterAmount', options: { columnPipe: { pipe: new KwhPipe() } } },
    { columnDescription: $localize`:@@AbstractEntitiesTableColumn7:Datum`, property: 'startTimestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
  ];
  
  public tableOptions: TableOptions = { hideActions: true, hideSearch: true };

  constructor(
    public transactionsService: TransactionsService, private routeDataService: RouteDataService, injector: Injector) {
    super(transactionsService, injector);
  }

  ngOnInit(): void {
    this.chargingStationId = this.routeDataService.params.key;
    super.ngOnInit();
    this.tableFunctions.pageSize = 25;
    this.tableFunctions.sortColumn = 'startTimestamp';
    this.tableFunctions.sortDirection = 'desc';
  }

  
  initializeEntities() {
    this.transactionsService.getTransactionsOfChargingStation(this.chargingStationId).subscribe(result => {
      this.entities = result;
      this.mapSuccessMessage();
      super.setupTable();
    }, error => {});
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

  mapSuccessMessage() {
    for (let transactionDto of this.entities) {
      transactionDto.successMessage = TransactionSuccess[transactionDto.success];
    }
  }
}
